import { Injectable, inject } from '@angular/core';
import { IMenuItem, MenuItemService } from './menu-item.service';

@Injectable({
  providedIn: 'root',
})
export class MenuSearchService {
  private menuItemService = inject(MenuItemService);

  /**
   * Filter menu items based on search term
   */
  public filterMenuItems(
    menuItems: IMenuItem[],
    filteredMenuItems: IMenuItem[] | undefined,
    searchTerm: string,
  ): IMenuItem[] {
    if (!menuItems) return menuItems;

    if (!searchTerm.trim()) {
      // When clearing search, preserve any selection changes made during filtering
      if (filteredMenuItems !== menuItems && filteredMenuItems) {
        this.menuItemService.syncSelectionState(filteredMenuItems, menuItems);
      }
      // Reset to show all items
      this.menuItemService.resetVisibility(menuItems);
      return menuItems;
    }

    // Create filtered copy that preserves selection state
    const filtered = this.menuItemService.deepCloneMenuItems(menuItems);
    this.menuItemService.applyFilter(filtered, (item) => item.name.toLowerCase().includes(searchTerm), true);

    return filtered;
  }
}
